import { useCallback, useEffect, useMemo, useState } from 'react';
import { Label, Select } from 'flowbite-react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import WarrantyApi from '../../Api/WarrantyApi';
import {
  Warranty,
  WarrantyStatusEnum,
  WarrantyStatusStringEnum,
} from '../../Models/Warranty';
import WarrantyListTable from './WarrantyListTable';

const STATUS_OPTIONS = [
  { value: 'All', label: 'All Statuses' },
  { value: 'New', label: 'New' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
];

export default function WarrantyList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [warrantyListData, setWarrantyListData] = useState<Warranty[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [statusFilter, setStatusFilter] = useState<string>('New');

  const getWarranties = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return WarrantyApi.getWarranties(0)
          .then((res) => {
            const sorted = [...res.data].sort((a, b) => {
              const dateA = new Date(a.date ?? '').getTime();
              const dateB = new Date(b.date ?? '').getTime();
              return dateB - dateA; // descending
            });
            setWarrantyListData(sorted);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getWarranties();
  }, [getWarranties]);

  const filteredData = useMemo(() => {
    if (statusFilter === 'All') {
      return warrantyListData;
    }
    return warrantyListData.filter(
      (w) =>
        WarrantyStatusStringEnum[w.statusId ?? WarrantyStatusEnum.New] ===
        statusFilter
    );
  }, [warrantyListData, statusFilter]);

  function deleteWarranty(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full p-4'>
          <div className='mx-1 flex flex-col items-start gap-3'>
            <h1 className='text-gray-900 font-bold text-4xl'>
              Warranty Claims
            </h1>
            <div className='w-56'>
              <Label htmlFor='warranty-status-filter' value='Status' />
              <Select
                id='warranty-status-filter'
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                {STATUS_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Select>
            </div>
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
            <WarrantyListTable
              data={filteredData}
              deleteWarranty={deleteWarranty}
              enableStatusColumnFilter={false}
            />
          </div>
        </div>
      </div>
    </>
  );
}
